export default __webpack_public_path__ + "static/Shut Down Training-77a3ae4346d1b8ff09e5f3d6010810e7.jpg";